export default "__VITE_ASSET__CbpU3zSR__"